import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COMPONENT_KEY } from "../constants";
var es = /*#__PURE__*/_defineProperty({}, COMPONENT_KEY, {
  PROFILE_LANGUAGE: 'Idiomas',
  SPANISH: 'Español',
  PORTUGUESE: 'Português'
});
export default es;